/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 13:39:58
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-03 22:27:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleEdit/config.tsx
 */
import { NEW } from '@/src/tools/constant';
export const breadcrumbData = (
  salesChannelUuid,
  salesChannelName,
  flashSaleUuid,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: '',
    name: getI18n('general.discount'),
  },
  {
    url: `/salesChannel/discounts/flashSale/list/${salesChannelUuid}`,
    name: getI18n('general.sider.flashSale'),
  },
  {
    url: '',
    name:
      flashSaleUuid == NEW
        ? getI18n('salesChannelFlashSale.list.addFlashSale')
        : getI18n('salesChannelFlashSale.list.editFlashSale'),
  },
];
